interface PayrailKycBrandProps {
  compact?: boolean
  centered?: boolean
}

export function PayrailKycBrand({ compact = false, centered = false }: PayrailKycBrandProps) {
  return (
    <div
      aria-label="Payrail KYC"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: centered ? 'center' : 'flex-start',
        gap: compact ? 8 : 10,
      }}
    >
      <span
        aria-hidden="true"
        style={{
          width: compact ? 22 : 28,
          height: compact ? 22 : 28,
          display: 'inline-grid',
          placeItems: 'center',
          border: '1px solid var(--accent)',
          color: 'var(--accent)',
          fontFamily: 'var(--mono)',
          fontSize: compact ? 10 : 12,
          fontWeight: 700,
          letterSpacing: '-0.04em',
        }}
      >
        PK
      </span>
      <span
        style={{
          color: 'var(--ink)',
          fontFamily: 'var(--mono)',
          fontSize: compact ? 14 : 18,
          fontWeight: 650,
          letterSpacing: '-0.03em',
        }}
      >
        PAYRAIL KYC
      </span>
    </div>
  )
}
